module.exports = __webpack_public_path__ + "img/b205a7359a8ae37cbd5699156e8b833d.png";